
enum LinkFolderType {
    folder = 1, movie = 2
}

export default LinkFolderType;